"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerEntryToJSON = exports.PlayerEntryFromJSONTyped = exports.PlayerEntryFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function PlayerEntryFromJSON(json) {
    return PlayerEntryFromJSONTyped(json, false);
}
exports.PlayerEntryFromJSON = PlayerEntryFromJSON;
function PlayerEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'label': json['label'],
        'subtitle': !runtime_1.exists(json, 'subtitle') ? undefined : json['subtitle'],
        'score': json['score'],
        'playerID': !runtime_1.exists(json, 'playerID') ? undefined : json['playerID'],
        'handicap': !runtime_1.exists(json, 'handicap') ? undefined : json['handicap'],
        'dynamicValue': (runtime_1.mapValues(json['dynamicValue'], _1.ScoreFromJSON)),
    };
}
exports.PlayerEntryFromJSONTyped = PlayerEntryFromJSONTyped;
function PlayerEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'label': value.label,
        'subtitle': value.subtitle,
        'score': value.score,
        'playerID': value.playerID,
        'handicap': value.handicap,
        'dynamicValue': (runtime_1.mapValues(value.dynamicValue, _1.ScoreToJSON)),
    };
}
exports.PlayerEntryToJSON = PlayerEntryToJSON;
